import { Directive, Inject, Injector, Input, Optional, SkipSelf } from '@angular/core';
import { AlignStyle, DescriptionControlDto } from '@core/services/api-clients';
import { WidgetDirective } from '@core/widgets/directives/widget.directive';
import { IScriptRunnerService, SCRIPT_RUNNER_SERVICE } from '@core/widgets/models/iscript-runner.service';
import { DescriptionControlComponent } from '@shared/reactive-controls/components/description/description-control.component';
import { EngineFormControlDirective } from './engine-form-control.directive';

@Directive({
  selector: 'app-description-control[engineDescriptionFormControl]',
  providers: [{ provide: EngineFormControlDirective, useExisting: EngineDescriptionFormControlDirective }],
})
export class EngineDescriptionFormControlDirective extends EngineFormControlDirective {
  protected get _descriptionBaseControl(): DescriptionControlComponent {
    return this._baseControl as DescriptionControlComponent;
  }

  @Input() set engineDescriptionFormControlDefinition(definition: DescriptionControlDto) {
    this._descriptionBaseControl.text = definition.value;
    this.engineControlDefinition = definition;
    this.textAlignStyle = definition.textAlign;
  }

  @Input() set textAlignStyle(textAlign: AlignStyle) {
    this._descriptionBaseControl.textAlignStyle = this.getTextAlignStyle(textAlign);
  }

  get textAlignStyle(): any {
    return this._descriptionBaseControl.textAlignStyle;
  }

  constructor(
    @Optional() @SkipSelf() parentWidget: WidgetDirective,
    @Inject(SCRIPT_RUNNER_SERVICE) scriptRunnerService: IScriptRunnerService,
    injector: Injector,
  ) {
    super(parentWidget, scriptRunnerService, injector);
  }
}
